import { getRemoHosts } from "config";
import { useI18n } from "i18n";
import { Errors, trackError } from "modules/monitoring";
import useNotificationActions from "modules/notification/hooks/useNotificationActions";
import authApi from "../../auth.api";

type ResetPasswordValues = {
  sendPasswordResetEmail: (
    email: string,
    continueURL?: string,
  ) => Promise<void>;
};
const useResetPassword = (): ResetPasswordValues => {
  const { t } = useI18n(["errorPage", "server"]);
  const { addErrorNotification, addSuccessNotification } =
    useNotificationActions();

  const sendPasswordResetEmail = async (
    email: string,
    continueURL?: string,
  ) => {
    const isRemoDomain = getRemoHosts().includes(window.location.host);
    const validContinueURL =
      isRemoDomain && continueURL ? continueURL : undefined;
    try {
      await authApi.sendPasswordResetEmailApi(email, validContinueURL);
      addSuccessNotification({
        message: t("auth:password.reset.email.send", {
          key: email,
        }),
        autoDismiss: 5,
      });
    } catch (error) {
      const errorMessage = error instanceof Error ? error.message : "";
      trackError(error, { label: Errors.PASSWORD_RESET_FAILED });

      addErrorNotification({
        message: t(errorMessage),
        autoDismiss: 5,
      });
    }
  };

  return { sendPasswordResetEmail };
};
export default useResetPassword;
